// Axios configuration
import axios from 'axios';

// Set default base URL for API requests
// In development, the proxy in package.json handles this
// In production, use relative URLs (nginx will proxy /api to backend)
// Or set REACT_APP_API_URL environment variable if needed
if (process.env.REACT_APP_API_URL) {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
} else if (process.env.NODE_ENV === 'production') {
  // In production, use relative URLs so nginx can proxy
  // This works when accessing via http://85.190.102.32 (port 80)
  axios.defaults.baseURL = '';
}

// Enable credentials for CORS
axios.defaults.withCredentials = true;

// Add request interceptor to include auth token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const AUTH_ENDPOINTS = /\/api\/auth\/(login|register|google|forgot-password|reset-password)(\/|$|\?)/;

const isPublicAuthPage = () => {
  const path = window.location.pathname;
  const publicPaths = ['/login', '/register', '/accept-invitation', '/forgot-password', '/reset-password'];
  return publicPaths.some((publicPath) => path === publicPath || path.startsWith(`${publicPath}/`));
};

const shouldRedirectOn401 = (error) => {
  const requestUrl = error.config?.url || '';
  if (AUTH_ENDPOINTS.test(requestUrl)) {
    return false;
  }
  if (isPublicAuthPage()) {
    return false;
  }
  return true;
};

// Add response interceptor for error handling
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && shouldRedirectOn401(error)) {
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axios;

